export default "__VITE_ASSET__BQMYqqkm__"